import { EventListCardData } from '../../event/event-types';

export const isOnDemandEvent = (event?: EventListCardData) => {
    if (!event) {
        return false;
    }
    
    return event?.isOnDemand || event?.eventExpireDate;
};
